<div class="flex w-full h-full items-center justify-center">
  <div class="flex flex-col items-center justify-center">
    <h1>{{'not-found.title' | translate}}</h1>
    <p class="text-brand-gray-600">{{'not-found.check-url' | translate}}</p>
  </div>
</div>
